
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { Integration } from '@/types/integrations';

export const useNuvemshopConfig = (integration?: Integration) => {
  const { toast } = useToast();
  const [isConfiguring, setIsConfiguring] = useState(false);

  const updateSyncSetting = async (setting: string, value: boolean) => {
    if (!integration) return;

    try {
      const newConfig = {
        ...integration.config,
        [setting]: value
      };

      toast({
        title: "Configuração atualizada",
        description: `${setting === 'sync_customers' ? 'Sincronização de clientes' : 
                     setting === 'sync_orders' ? 'Sincronização de pedidos' : 
                     'Criação automática de cashback'} ${value ? 'ativada' : 'desativada'}`
      });
    } catch (error: any) {
      toast({
        title: "Erro ao atualizar configuração",
        description: error.message,
        variant: "destructive"
      });
    }
  };

  return {
    updateSyncSetting,
    isConfiguring,
    setIsConfiguring
  };
};
